import {
    createLocaleTextWithDevI18nKey,
    getLocale,
    setLocale,
    useLocaleText,
    type LocaleTextPrinter,
} from '@meitu/xdesign-i18n';
import { localeTextMap, type LocaleCode, type LocaleText } from './locales';

type LocaleStore = {
    locale: LocaleCode;
    $t: LocaleTextPrinter<LocaleText>;
};

const localStoreCache: Partial<Record<LocaleCode, LocaleStore>> = {};

export const initLocaleStore = (locale: LocaleCode) => {
    setLocale(locale);
};

export const getLocaleStore = (_locale?: LocaleCode) => {
    const locale: LocaleCode = _locale || getLocale() || 'zh-Hans';
    const localeText = (localeTextMap[locale] ?? localeTextMap['zh-Hans']) as unknown as Record<string, unknown>;

    if (!localStoreCache[locale]) {
        localStoreCache[locale] = {
            locale,
            $t: createLocaleTextWithDevI18nKey(localeText, 'saasEditor'),
        } as unknown as LocaleStore;
    }

    return localStoreCache[locale]!;
};

export const useLocaleStore = () => {
    const locale = useLocaleText<LocaleCode>();

    return getLocaleStore(locale);
};
